module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vurin25-8648af4b722d8bf7104632375445a83f.jpg";